import { IDocumentTemplate } from 'types/entities';
import { EntityService } from '../entity.service';


class DocumentTemplatesService extends EntityService<IDocumentTemplate> {
  readonly entityName = 'document_template';
}

export default new DocumentTemplatesService();
